import { createAction } from 'typesafe-actions';

import { EAdvancedFilterType } from 'shared/enums/EAdvancedFilterType';
import { EFilterType } from 'shared/enums/EFilterType';

export const validateRangeFilterAction = createAction('filters/validateRangeFilter')<
  EFilterType | EAdvancedFilterType
>();
